import img1 from "../../assets/Home/logo1.png";
import img2 from "../../assets/Home/logo2.png";
import img3 from "../../assets/Home/logo3.png";
import img4 from "../../assets/Home/logo4.png";

import "./ImageSection.scss";

const ImageSection = () => {
  return (
    <div className="image">
      <img src={img1} alt="" />
      <img src={img2} alt="" />
      <img className="third-img" src={img3} alt="" />
      <img className="fourth-img" src={img4} alt="" />
    </div>
  );
};

export default ImageSection;
